<hmf-checkbox
  class="compare-checkbox hmf-pt-xxs hmf-pb-xxxs"
  [label]="'Compare'"
  [checked]="checked"
  (eventChange)="onCompareChange($event)"
>
</hmf-checkbox>